import * as React from 'react'
import { Paper, Typography, Box, Grid, Button } from "@mui/material"
import {Navigate, useLoaderData} from 'react-router-dom'
import {DataGridPro} from '@mui/x-data-grid-pro'
import CheckIcon from '@mui/icons-material/Check'
import axios from 'axios'
import { ErrorAlert } from '../../alerts/ErrorAlert'
import { setData, axiosErrorHandling } from '../../misc/other'


const columns = [
    {field: 'id', headerName:'ID', flex: 1},
    {field: 'original_creditor', headerName: 'Originator', flex: 4.5 },
    {field: 'original_account_number', headerName: 'Account #', flex: 2},
    {field: 'account_balance', description: 'This is not the ammount you will pay after you Name Your Settlement',
    headerName: 'Balance ($)', flex: 4 },
    {field: 'account_status', headerName: 'Status', flex: 4}
]

export const UserAccounts = () =>{


    
    let loaderData = useLoaderData()
    
    

    let accounts = loaderData.accounts
    let promoCodes = loaderData.promo_codes_used.promoCodes || []
    window.localStorage.setItem('userpromocodes', JSON.stringify(promoCodes))
    
    

    const data = setData(accounts)
    
    const activeAccounts = data.filter(element => {
        

        if (element.account_status !== "PAID" && element.account_status !== "Reconciled"){
           
            return true;
        } 
            return false;
        
    }).length;
    
    

    const [accountSelected, setAccountSelected] = React.useState([])
    const [accountStatus, setAccountStatus] = React.useState(null)
    const [disableButton, setDisableButton] = React.useState(true)
    const [totalDue, setTotalDue] = React.useState(0)
    const [pathName, setPathName] = React.useState('/user/confirmaccounts')
    const [isReady, setIsReady] = React.useState(false)
    const [isSubmitting, setIsSubmitting] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')
    

    const closeError = () =>{
        setError(false)
    }

   
    React.useLayoutEffect(()=>{
        
        const whereToGo =(account_status)=> {
            switch(account_status) {
                
                case 'Settled':
                case 'Partial':
                case 'Recurring': 
                case 'Money Order':  
                    setPathName('/user/payment');
                    break
                case '1099-C':   
                case 'Already_Settled' :
                case 'Bankruptcy' : 
                case 'Ready to Settle' :
                case 'Deceased' : 
                case 'Wrong_Identity' :
                       
                    setPathName('/user/confirmaccounts')
                    break
                case 'PAID':
                case 'Reconciled':    
                    return setDisableButton(true)
                   
                case 'Confirmed' :
                    setPathName('/user/settlement')
                    break
                
                default: 
                setPathName('/user/confirmaccounts')
                break
                }
        
        }


            if(accountStatus !== null){           
                   
        
    for(let j=0; j<accountSelected.length; j++){
     if (accountSelected[j].account_status!==accountStatus){
        setDisableButton(true)

    }else{
        
        setDisableButton(false)
        whereToGo(accountStatus)}
}

            }
    
    },[accountSelected, accountStatus])

   
    const buttonClick = async () => {

        try{

        setIsSubmitting(true)
        let almostReadyAccounts = accountSelected
        let context =JSON.parse(window.localStorage.getItem('context'))
    context.active_accounts = activeAccounts
    context.accounts_settled = accountSelected.length
    window.localStorage.setItem('context', JSON.stringify(context))
       

        for(let r=0; r<almostReadyAccounts.length; r++){
            almostReadyAccounts[r].per_of_settlement =Number((almostReadyAccounts[r].account_balance/totalDue).toFixed(2)) 
        }
        
        setAccountSelected(almostReadyAccounts)

        axios({
            method: "POST",
            url: 'api/oracle3/persettlement',
            data: {almostReadyAccounts, active_accounts: activeAccounts}
        }).then(res=>{
            
            for(let m=0; m<almostReadyAccounts.length; m++){
                almostReadyAccounts[m].settlement_per = res.data[m].settlement_per
               
            }
            setAccountSelected(almostReadyAccounts)
            setIsReady(true)

        }).catch(err=>{
            let errMessage = axiosErrorHandling(err)
            setErrorMessage(errMessage)
            setError(true)
            setDisableButton(false)
            setIsSubmitting(false)
        })
    }
    catch(err){
        setErrorMessage('Something went wrong with the call: ', err)
        setError(true)
        setDisableButton(false)
        setIsSubmitting(false)
    }
        
    }
        

    const rowClick = (row) =>{
        
        const newArray = Array.from(row.ids)
         
        if(!newArray.length){setDisableButton(true)}

        else{
        
        let rowsSelected = []
        let i = 0
        let total = 0    
        
        while (i < (data.length)){           
        if (newArray.includes(data[i].id)){
                      rowsSelected.push(data[i])
                      total += data[i].account_balance
                      setAccountSelected(rowsSelected)
                      setAccountStatus(rowsSelected[0].account_status)
                    
                      setTotalDue(total)
                      
                      
        }
        
        i++
        
           }
           
        }
    }

    

    let accountStatusWarning;
if(isReady) return(<Navigate  to={pathName} state={{accounts: accountSelected, totalDue: totalDue, promoCodesUsed: promoCodes}}/>)

if (disableButton) 
{accountStatusWarning = <React.Fragment><Grid container direction='row' sx={{justifyContent:'flex-end'}} ><Grid size={{lg: 6, md: 8, sm: 10}}> <Typography variant='h6'color='primary' gutterBottom={true}> *Select items with the same account status or select one debt.</Typography> </Grid></Grid></React.Fragment>}
else{<Grid></Grid>}


 return(
    
    
        <Box sx={{minHeight:'60vh', mt: 15, mb: 2}}>
            <ErrorAlert open={error} error={errorMessage} handleClose={closeError}/>
        <Grid container direction='row' sx={{alignItems:'center', justifyContent:'center'}}>
            <Grid></Grid>
            <Grid size={{xs: 12, sm: 11, lg: 9, xl: 8}}>
                <Typography color='secondary' variant='h6' align='center' sx={{display:'flex', justifyContent:'center'}} gutterBottom={true}>“Check the box(s) to the left of the items you want to settle, then click CONTINUE at the bottom of this page. All items selected must have the same status</Typography>
            </Grid>
        </Grid>  

   <Grid container direction='row' sx={{justifyContent:'center', alignItems:'center', alignContent:'center'}}>
    <Grid size={{sm: 9, lg: 8}}>
        <Paper sx={{minHeight: 90}}>
            <DataGridPro
            
                   rowHeight={45}
                   rows={data}
                   columns={columns} 
                   autoPageSize={true} 
                   checkboxSelection 
                   columnBufferPx={150} 
                   hideFooter={false}
                   onRowSelectionModelChange={rowClick}
                    
                                   
                   />
        </Paper>
    </Grid>
   </Grid>
<Grid container direction='row' sx={{
    mt: 2
}}>
<Grid size={{xs: 6, sm: 8, lg: 9}}>
</Grid>
<Grid>
<Button
        loading={isSubmitting}
        loadingPosition='end'
        variant='contained' 
        color='secondary'
        size = 'large'
        onClick={buttonClick}
        type = 'button' 
        disabled={disableButton || !accountSelected.length} 
        endIcon= {<CheckIcon/>}>
            CONTINUE</Button> 
</Grid>
{accountStatusWarning}
</Grid>
<Grid container direction='column'sx={{alignItems:'center', justifyItems:'center'}} > 
</Grid>
</Box>
   
      
   
)

}